import React from 'react';
import propTypes from 'prop-types';
import { Feedback } from 'react-nice-inputs';

const InputAid = ({validation}) => {
  return (validation.isValid) ? '' : <Feedback>Input is required or invalid</Feedback>;
};

InputAid.propTypes = {
  validation: propTypes.object
};

export default InputAid;



// WEBPACK FOOTER //
// ./js/components/step4/InputAid.js